export default __webpack_public_path__ + "static/media/photo--sm--reception.bbfdb0a3.jpg";